import { useState } from 'react'
import { Block, DefaultBlockSchema } from '@packages/blocknote-core'
import {
  EditorContentContext,
  EditorContentDispatchContext,
  NeedsUploadContext,
  NeedsUploadDispatchContext,
} from './context'

// This lets us share the content of the editor with WeekView (timeblocking) to calculate the timeblocks.
// Have added this so that we don't trigger a re-render upon every content change of the editor.
export function EditorContentProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [editorContent, setEditorContent] = useState<
    Block<DefaultBlockSchema>[]
  >([])
  const [needsUpload, setNeedsUpload] = useState(false)

  return (
    <EditorContentContext.Provider value={editorContent}>
      <EditorContentDispatchContext.Provider value={setEditorContent}>
        <NeedsUploadContext.Provider value={needsUpload}>
          <NeedsUploadDispatchContext.Provider value={setNeedsUpload}>
            {children}
          </NeedsUploadDispatchContext.Provider>
        </NeedsUploadContext.Provider>
      </EditorContentDispatchContext.Provider>
    </EditorContentContext.Provider>
  )
}
